// Materialize bytes before multipart serialization. WebKit can send an empty
// body when FormData contains a File restored from IndexedDB.
export async function prepareUploadFile(file) {
  if (!(file instanceof Blob) || file.size === 0) {
    throw new Error("Une photo est vide ou indisponible. Veuillez la sélectionner à nouveau.");
  }

  let bytes;
  try {
    bytes = typeof file.arrayBuffer === "function"
      ? await file.arrayBuffer()
      : await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
          reader.onabort = () => reject(new Error("File read aborted"));
          reader.readAsArrayBuffer(file);
        });
  } catch (_) {
    throw new Error("Impossible de lire une photo. Veuillez la sélectionner à nouveau.");
  }

  if (!bytes || bytes.byteLength !== file.size) {
    throw new Error("Une photo est incomplète. Veuillez la sélectionner à nouveau.");
  }

  return {
    blob: new Blob([bytes], { type: file.type || "application/octet-stream" }),
    filename: file.name || "blob",
  };
}
